import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { useLocation } from "react-router-dom";
import ulaliveLogo from "../../assets/images/ulalive-logo.svg";
const { YoutubeDataAPI } = require("youtube-v3-api")

const YoutubeVideos = () => {
    const location = useLocation();
    const [videos, setVideos] = useState([]);
    const [playList, setPlayList] = useState("");
    const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

    useEffect(() => {
        if (location.hash) {
            setPlayList(location.hash.replace("#", ""));
        }
    }, [location])

    useEffect(() => {
        const api = new YoutubeDataAPI(API_KEY);
        api.searchPlaylistItems(playList, 50).then((x) => {
            setVideos(x.items);
        })
    }, [playList]);

    return (
        <div className="px-2 sm:px-4 lg:px-8 py-7">
            <div className="mb-[17px]">
                <h1 className="text-2xl font-bold text-ebony-color whitespace-nowrap">
                    View our videos
                </h1>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3.5">
                {
                    videos.map((video) => {
                        return (
                            <div
                                key={video.id}
                                className="bg-white border w-full border-black-10 rounded-lg mx-auto"
                            >
                                <div className="mb-2.5">
                                    <div className="player-wrapper">
                                        <ReactPlayer
                                            width="100%"
                                            height="100%"
                                            className="react-player"
                                            url={"https://www.youtube.com/embed/" + video.contentDetails.videoId}
                                        />
                                    </div>
                                </div>
                                <div className="px-4 pb-4">
                                    <div className="text-center sm:text-left">
                                        <h3 className="text-base text-ebony-color font-bold mb-2 ">
                                            {video.snippet.title}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default YoutubeVideos;
